



import Vue from 'vue';
import 'element-ui/lib/theme-chalk/reset.css';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
import ElementUI from 'element-ui';
import 'element-theme-chalk';

Vue.use(ElementUI, { locale });

export default /*#__PURE__*/Vue.extend({
    name: 'glInit', // vue component name
    data() {
        return {
        };
    },
});
